import { observable, action, makeObservable } from "mobx"
import { getCheckCarListPage } from 'requests/entranceInspection'

class carProblem {
    constructor() {
        makeObservable(this)
    }
    // 待处理
    @observable pendingList = []
    @observable pendingPageModal = {
        page: 1,
        pageSize: 10,
        total: 0
    }
    @observable pendingCondition = {
        "boutiqueCar": null,
		"carBrand": "",
		"checkDate": "",
		"checkResult": 2,
		"checkResultStatus": null,
		"licensePlate": "",
		"warehouseId": ""
    }

    // 已处理
    @observable acceptList = []
    @observable acceptPageModal = {
        page: 1,
        pageSize: 10,
        total: 0
    }
    @observable acceptCondition = {
        "boutiqueCar": null,
		"carBrand": "",
		"checkDate": "",
		"checkResult": 3,
		"checkResultStatus": null,
		"licensePlate": "",
		"warehouseId": ""
    }

    // 待处理
    @action getPendingList(pageModal, condition) {
        const { page, pageSize } = pageModal || this.pendingPageModal

        getCheckCarListPage({
            pageNum: page,
            pageSize,
            condition: condition || this.pendingCondition
        }).then(resp => {
            if (resp && !resp.code) {
                this.pendingList = resp.data ? resp.data : [];
                this.pendingPageModal = resp.pageModal
            }
        })
    }

    // 已处理
    @action getAcceptList(pageModal, condition) {
        const { page, pageSize } = pageModal || this.acceptPageModal

        getCheckCarListPage({
            pageNum: page,
            pageSize,
            condition: condition || this.acceptCondition
        }).then(resp => {
            if (resp && !resp.code) {
                this.acceptList = resp.data ? resp.data : [];
                this.acceptPageModal = resp.pageModal
            }
        })
    }

    //  重置或查询 修改condition
    @action resetForm = (condition, key) => {
        if (key === 1) {
            this.pendingCondition = {
                ...condition,
                checkResult: 2
            }
            this.pendingPageModal = {
                page: 1,
                pageSize: 10
            }
        }
        if (key === 2) {
            this.acceptCondition = {
                ...condition,
                checkResult: 3
            }
            this.acceptPageModal = {
                page: 1,
                pageSize: 10
            }
        }
    }
}

export default carProblem